export const engAndNumber = (value)=>{
    return value.replace(/[^a-zA-Z0-9]/g, '');
}